export default __webpack_public_path__ + "static/media/icon-node-tipo-escrita.d2369003.svg";